/**
 * Copyright (C) Sitevision AB 2002-2026, all rights reserved
 *
 * @author albin
 */

import globalEvents from './globalEvents';

const CAPTCHA_WIDGET_SELECTOR =
  '[data-sv-captcha-provider][data-sv-captcha-state]';
const CAPTCHA_STATE_CHANGE_EVENT = 'SVWebAppCaptchaStateChanged';
const SDK_CAPTCHA_STATE_CHANGE_EVENT = 'svCaptcha:stateChanged';

const getWidgetStatus = function (widget) {
  const state = widget.getAttribute('data-sv-captcha-state');

  return {
    captchaId: widget.id,
    widget: widget,
    provider: widget.getAttribute('data-sv-captcha-provider'),
    state: state,
    valid: state === 'verified',
  };
};

const resolveContainer = function (container) {
  if (typeof container === 'string') {
    return document.getElementById(container);
  }

  if (container === null || typeof container === 'undefined') {
    return null;
  }

  if (!(container instanceof Element)) {
    throw new TypeError(
      'Captcha container must be an HTMLElement or a DOM element id',
    );
  }

  return container;
};

const findWidget = function (container) {
  const resolvedContainer = resolveContainer(container);

  if (!resolvedContainer) {
    return null;
  }

  const widgets = [];
  if (resolvedContainer.matches(CAPTCHA_WIDGET_SELECTOR)) {
    widgets.push(resolvedContainer);
  }
  resolvedContainer
    .querySelectorAll(CAPTCHA_WIDGET_SELECTOR)
    .forEach(function (widget) {
      widgets.push(widget);
    });

  if (widgets.length > 1) {
    throw new Error(
      'Captcha container contains multiple widgets; use a narrower container',
    );
  }

  return widgets[0] || null;
};

document.addEventListener(CAPTCHA_STATE_CHANGE_EVENT, function (event) {
  const widget = event.target;

  if (
    !(widget instanceof Element) ||
    !widget.matches(CAPTCHA_WIDGET_SELECTOR)
  ) {
    return;
  }

  globalEvents.trigger(SDK_CAPTCHA_STATE_CHANGE_EVENT, getWidgetStatus(widget));
});

export const csrf = {
  getToken: function () {
    var token = window.sv.PageContext.csrfToken;

    return token || null;
  },
  getParameterName: function () {
    return 'sv.csrfToken';
  },
  getHeaderName: function () {
    return 'X-CSRF-Token';
  },
};
export const captcha = {
  init: () => {
    document.dispatchEvent(new Event('SVInitCaptchaTrigger'));
  },
  getState: (container) => {
    const widget = findWidget(container);

    return widget ? getWidgetStatus(widget) : null;
  },
};
